import { render, staticRenderFns } from "./emaillayout1.vue?vue&type=template&id=4481a23a"
import script from "./emaillayout1.vue?vue&type=script&lang=js"
export * from "./emaillayout1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports